import { isStrategy } from '@tradingblock/types';
import { CallCalendar, PutCalendar } from '..';
export const isCalendar = (strategy) => isStrategy([CallCalendar, PutCalendar], strategy);
//# sourceMappingURL=utility.js.map